import React, { useState } from 'react'
import CustomButton from '../CustomButton'
import { FaRegThumbsDown, FaRegThumbsUp, FaThumbsUp, FaThumbsDown } from 'react-icons/fa'
import styles from './VoteButton.module.css'
import SubmitFeedbackModal from '../modals/SubmitFeedbackModal'

/**
 * 
 * @param {string} title - Button title
 * @param {string} variant - Button variant (color or default)
 * @param {Function} onVote - Vote handler function (receives voteType, itemId, feedbackMessage)
 * @param {string} itemId - Unique identifier for the item being voted on
 * @param {string} feedbackType - Current vote status ('positive', 'negative', or null)
 * @param {string} itemType - Type of item being voted on
 * @param {string} className - Additional CSS classes
 * @returns {JSX.Element} - VoteButton component
 * @description A button component with thumbs up and down icons for voting with state management.
 */

export const VoteButton = ({ 
  title, 
  variant, 
  onVote, 
  itemId, 
  feedbackType = null, 
  itemType = "research-spotlight-tool",
  className 
}) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  
  console.log(`VoteButton ${itemId} - feedbackType:`, feedbackType);
  
  let thumbsUpColor = "rgb(18, 142, 4)";
  let thumbsDownColor = "rgb(255, 11, 23)";
  if (variant === "color") {
    thumbsUpColor = "#3CC44A";
    thumbsDownColor = "#DC5A5A";
  }

  const handleThumbsUpClick = (e) => {
    e.stopPropagation();
    console.log(`Thumbs up clicked for ${itemId}, current feedbackType:`, feedbackType);
    if (feedbackType === "positive") {
      onVote(null, itemId, null);
    } else {
      onVote("positive", itemId, null);
    }
  };

  const handleThumbsDownClick = (e) => {
    e.stopPropagation();
    console.log(`Thumbs down clicked for ${itemId}, current feedbackType:`, feedbackType);
    if (feedbackType === "negative") {
      onVote(null, itemId, null);
    } else {
      setShowFeedbackModal(true);
    }
  };

  const handleFeedbackSubmit = (feedbackMessage) => {
    onVote("negative", itemId, feedbackMessage);
    setShowFeedbackModal(false);
  };

  return (
    <>
      <CustomButton
        variant="border bg-white rounded-3"
        className={`btn-sm px-3 py-2 w-100 d-flex justify-content-between align-items-center border ${className}`}
        onClick={() => {}} // Disable main button click
      >
        <span className={`text-start`} style={{color:variant==="color"?"#000":"#0BA7FF"}}>
          {title || "Cast your vote"}
        </span>
        <div className="d-flex gap-2">
          <button 
            className={`btn btn-sm p-0 ${styles.hand}`}
            onClick={handleThumbsUpClick}
          >
            {feedbackType === "positive" ? (
              <FaThumbsUp size={18} color="green" />
            ) : (
              <FaRegThumbsUp size={18} color={thumbsUpColor}/>
            )}
          </button>
          <button 
            className={`btn btn-sm p-0 ${styles.hand}`}
            onClick={handleThumbsDownClick}
          >
            {feedbackType === "negative" ? (
              <FaThumbsDown
                size={18}
                color="red"
                style={{ transform: "scaleX(-1)" }}
              />
            ) : (
              <FaRegThumbsDown 
                size={18} 
                color={thumbsDownColor}
                style={{ transform: "scaleX(-1)" }}
              />
            )}
          </button>
        </div>
      </CustomButton>
      
      <SubmitFeedbackModal
        show={showFeedbackModal}
        handleClose={() => setShowFeedbackModal(false)}
        itemId={itemId}
        itemType={itemType}
        onSuccess={handleFeedbackSubmit}
        vote={feedbackType === "positive" ? true : false}
        additionalData={[]}
      />
    </>
  )
}